// eslint-disable-next-line import/no-extraneous-dependencies
import { ObjectWithObjectID } from '@algolia/client-search';
import algoliasearch from 'algoliasearch';
import invariant from 'invariant';
import queryString from 'query-string';

import { RichError } from 'utils/RichError';
import { trackError } from 'utils/trackError';

import {
  AlgoliaApiValidUntilError,
  isValidUntilError,
} from './AlgoliaApiValidUntilError';

type Args = {
  config: Readonly<{ appId: string; apiKey: string }>;
  index: string;
  id: string;
  attributes: Array<string>;
};

export async function algoliaApiGetObject<T>({
  config: { appId, apiKey },
  index,
  id,
  attributes,
}: Args): Promise<void | (T & ObjectWithObjectID)> {
  invariant(appId, 'Search app id must be configured');
  invariant(apiKey, 'Search api key must be configured');
  const client = algoliasearch(appId, apiKey);
  const indexClient = client.initIndex(index);

  try {
    const response = await indexClient.getObject<T>(id, {
      attributesToRetrieve: attributes,
    });

    return response;
    // TODO: fix types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    if (isValidUntilError(e)) {
      throw new AlgoliaApiValidUntilError();
    }

    trackError(
      new RichError('Algolia POST request error.', {
        debugData: e.debugData,
        errorMessage: e.message,
        requestParams: queryString.stringify({
          id,
          attributes,
        }),
        statusCode: e.statusCode,
        response: e.response,
      }),
    );
  }
}
